import React, { useState, useEffect, useCallback } from 'react';

// 🤖 Saudadora (SDR Virtual) — central de controle da abordagem automática:
// status ao vivo, configurações (teto/dia, ritmo, janela) e a documentação
// de como operar e replicar. Só o Vagner acessa (rota protegida no App.js).

const token = () => localStorage.getItem('token');
const apiGet = (p) => fetch(`/${p}${p.includes('?') ? '&' : '?'}_=${Date.now()}`, { headers: { Authorization: `Bearer ${token()}`, 'Cache-Control': 'no-cache' } }).then(r => r.json());
const apiSend = (p, m, b) => fetch(`/${p}`, { method: m, headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` }, body: b ? JSON.stringify(b) : undefined }).then(r => r.json());

const card = { background: '#fff', border: '1px solid #c8d0da', borderRadius: 10, padding: 16 };
const num = { fontSize: 26, fontWeight: 800, color: '#0a1628', lineHeight: 1.1 };
const rotulo = { fontSize: 11, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.04em' };
const campo = { width: '100%', padding: '8px 10px', border: '1px solid #c8d0da', borderRadius: 8, fontSize: 14 };
const lbl = { fontSize: 12, fontWeight: 700, color: '#0a1628', display: 'block', marginBottom: 4 };

// 📸 Miniatura do último print do aparelho: o <img> puro não manda o token,
// então buscamos via fetch autenticado e viramos blob. Atualiza a cada 60s.
function MiniPrint({ id }) {
  const [url, setUrl] = React.useState('');
  React.useEffect(() => {
    let vivo = true; let atual = '';
    const buscar = () => fetch(`/sdr/virtual/print/${id}?t=${Date.now()}`,
      { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then(r => r.ok ? r.blob() : null)
      .then(b => { if (vivo && b) { if (atual) URL.revokeObjectURL(atual); atual = URL.createObjectURL(b); setUrl(atual); } })
      .catch(() => {});
    buscar();
    const t = setInterval(buscar, 60000);
    return () => { vivo = false; clearInterval(t); if (atual) URL.revokeObjectURL(atual); };
  }, [id]);
  if (!url) return null;
  return <img src={url} alt="print da tela" onClick={() => window.open(url, '_blank')}
    style={{ height: 54, borderRadius: 4, border: '1px solid #dbe2ea', cursor: 'zoom-in' }} />;
}

export default function Saudadora() {
  const [st, setSt] = useState(null);
  const [cfg, setCfg] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [msg, setMsg] = useState('');

  const carregar = useCallback(async () => {
    const d = await apiGet('sdr/virtual/status').catch(() => null);
    if (d && !d.erro) {
      setSt(d);
      setCfg(c => c || { ...d.config, saudacoes: (d.config.saudacoes || []).join('\n'), dialogos: (d.config.dialogos || []).join('\n') });
    }
  }, []);

  useEffect(() => {
    carregar();
    const t = setInterval(carregar, 60000); // atualiza sozinho a cada 1min
    return () => clearInterval(t);
  }, [carregar]);

  async function salvar() {
    setSalvando(true); setMsg('');
    const r = await apiSend('sdr/virtual/config', 'PUT', cfg).catch(() => ({ erro: 'falha' }));
    setSalvando(false);
    if (r.ok) {
      setMsg('✓ Salvo — a ponte adota na próxima rodada (até 30 min).');
      setCfg({
        teto_dia: r.teto_dia, min_intervalo_min: r.min_intervalo_min, max_intervalo_min: r.max_intervalo_min,
        hora_ini: r.hora_ini, hora_fim: r.hora_fim, tipo_abordagem: r.tipo_abordagem,
        notificar_whatsapp: r.notificar_whatsapp,
        aquecer_por_saudacao: r.aquecer_por_saudacao,
        saudacoes: (r.saudacoes || []).join('\n'), dialogos: (r.dialogos || []).join('\n'),
      });
      carregar();
    }
    else setMsg('✗ ' + (r.erro || 'Não salvou — tente de novo.'));
  }

  async function rearmarTeste() {
    const r = await apiSend('sdr/virtual/testar', 'POST').catch(() => ({ erro: 'falha' }));
    if (r.ok) setMsg(`✓ Teste re-armado (${r.rearmados} contato). A ponte envia na próxima rodada — ou reinicie a janela da ponte no PC pra ser imediato.`);
    else setMsg('✗ ' + (r.erro || 'Não consegui re-armar.'));
    carregar();
  }

  // ── Aparelhos (frota) ──
  const MODO_INFO = {
    prospectar: { rot: '🎯 Prospectando', cor: '#15803d', bg: '#f0fdf4' },
    aquecer: { rot: '🔥 Aquecendo', cor: '#b45309', bg: '#fffbeb' },
    pausado: { rot: '⏸️ Pausado', cor: '#6b7280', bg: '#f3f4f6' },
  };
  async function editarAparelho(id, patch) {
    const r = await apiSend(`sdr/virtual/aparelhos/${id}`, 'PUT', patch).catch(() => ({ erro: 'falha' }));
    if (r.erro) setMsg('✗ ' + r.erro); else carregar();
  }
  async function addAparelho() {
    const nome = window.prompt('Nome do aparelho (ex.: Bianca, Celular 02):');
    if (!nome) return;
    const r = await apiSend('sdr/virtual/aparelhos', 'POST', { nome }).catch(() => ({ erro: 'falha' }));
    if (r.ok) { setMsg(`✓ "${r.aparelho.nome}" criado (ID ${r.aparelho.id}) — use esse ID no 3-LIGAR-PONTE.bat do PC.`); carregar(); }
    else setMsg('✗ ' + (r.erro || 'não criou'));
  }
  async function removerAparelho(ap) {
    if (!window.confirm(`Remover o aparelho "${ap.nome}"? (o celular some do painel; nada é apagado nas listas)`)) return;
    await apiSend(`sdr/virtual/aparelhos/${ap.id}`, 'DELETE').catch(() => {});
    carregar();
  }

  const numInput = (chave, min, max) => (
    <input type="number" min={min} max={max} style={campo} value={cfg?.[chave] ?? ''}
      onChange={e => setCfg({ ...cfg, [chave]: e.target.value })} />
  );

  const fmtHora = (iso) => iso ? new Date(iso).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '';

  return (
    <div style={{ maxWidth: 1000, margin: '0 auto', padding: '18px 14px 60px' }}>
      <h1 style={{ fontSize: 22, color: '#0a1628', margin: '0 0 2px' }}>🤖 Saudadora — SDR Virtual</h1>
      <p style={{ fontSize: 13, color: '#6b7280', margin: '0 0 16px' }}>
        O celular dedicado aborda os leads por áudio no WhatsApp, sozinho, no ritmo configurado aqui.
      </p>

      {/* ── Status ao vivo ── */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 10, marginBottom: 16 }}>
        <div style={card}><div style={rotulo}>Fila agora</div><div style={num}>{st ? st.fila_total : '…'}</div><div style={{ fontSize: 11, color: '#6b7280' }}>contatos novos nas listas ligadas</div></div>
        <div style={card}><div style={rotulo}>Abordados hoje</div><div style={num}>{st ? `${st.abordados_hoje}/${st.config.teto_dia}` : '…'}</div><div style={{ fontSize: 11, color: '#6b7280' }}>{st ? `${st.vagas_hoje} vaga(s) restante(s)` : ''}</div></div>
        <div style={card}><div style={rotulo}>Listas ligadas</div><div style={num}>{st ? st.listas.length : '…'}</div><div style={{ fontSize: 11, color: '#6b7280' }}>ligue no botão 🤖 da tela SDR</div></div>
        <div style={card}><div style={rotulo}>Janela de envio</div><div style={num}>{st ? `${st.config.hora_ini}h–${st.config.hora_fim}h` : '…'}</div><div style={{ fontSize: 11, color: '#6b7280' }}>ritmo {st ? `${st.config.min_intervalo_min}–${st.config.max_intervalo_min} min` : ''}</div></div>
      </div>

      {/* ── Esperando atendimento humano ── */}
      {st && st.esperando_atendimento && st.esperando_atendimento.length > 0 && (
        <div style={{ ...card, marginBottom: 16, border: '2px solid #f59e0b', background: '#fffbeb' }}>
          <div style={{ fontSize: 15, fontWeight: 800, color: '#92400e', marginBottom: 8 }}>
            💬 {st.esperando_atendimento.length} lead(s) responderam — esperando atendimento humano
          </div>
          {st.esperando_atendimento.map(c => (
            <div key={c.id} style={{ display: 'flex', justifyContent: 'space-between', gap: 8, padding: '7px 0', borderBottom: '1px solid #fde68a', fontSize: 13.5, flexWrap: 'wrap' }}>
              <span><b>{c.nome}</b> · {c.telefone}</span>
              <span style={{ color: '#92400e' }}>respondeu {fmtHora(c.respondeu_em)}</span>
            </div>
          ))}
          <div style={{ fontSize: 12, color: '#92400e', marginTop: 8 }}>
            A conversa já foi aberta na tela do celular da saudadora. Depois de atender, registre o desfecho na lista do SDR (vira oportunidade, sem interesse etc.) — aí sai daqui.
          </div>
        </div>
      )}

      {/* ── Aparelhos (frota) ── */}
      <div style={{ ...card, marginBottom: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8, marginBottom: 10 }}>
          <div style={{ fontSize: 15, fontWeight: 800, color: '#0a1628' }}>📱 Aparelhos da frota</div>
          <button onClick={addAparelho} style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 8, padding: '7px 16px', fontWeight: 700, fontSize: 13, cursor: 'pointer' }}>+ Aparelho</button>
        </div>
        {st && (!st.aparelhos || st.aparelhos.length === 0) && (
          <div style={{ fontSize: 13, color: '#6b7280' }}>
            Nenhum aparelho ainda. Clique <b>+ Aparelho</b> pra dar um nome (ex.: "Bianca") — ou ligue a ponte no PC com um ID, que ele aparece aqui sozinho em <b>modo pausado</b>.
          </div>
        )}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 10 }}>
          {st && (st.aparelhos || []).map(ap => {
            const mi = MODO_INFO[ap.modo_efetivo] || MODO_INFO.pausado;
            const emAlmoco = ap.modo === 'prospectar' && ap.modo_efetivo === 'aquecer';
            return (
              <div key={ap.id} style={{ border: `1px solid ${ap.online ? '#bbf7d0' : '#e5e7eb'}`, borderRadius: 10, padding: 12, background: '#fff' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
                  <span style={{ width: 9, height: 9, borderRadius: '50%', background: ap.online ? '#16a34a' : '#cbd5e1', flexShrink: 0 }} title={ap.online ? 'online' : 'offline'} />
                  <input defaultValue={ap.nome} onBlur={e => e.target.value.trim() && e.target.value !== ap.nome && editarAparelho(ap.id, { nome: e.target.value.trim() })}
                    style={{ fontSize: 14, fontWeight: 800, color: '#0a1628', border: 'none', borderBottom: '1px dashed #d1d5db', flex: 1, minWidth: 0, outline: 'none' }} title="Clique pra renomear" />
                  <button onClick={() => removerAparelho(ap)} title="Remover" style={{ background: 'none', border: 'none', color: '#dc2626', cursor: 'pointer', fontSize: 15 }}>×</button>
                </div>
                <div style={{ fontSize: 10.5, color: '#9ca3af', marginBottom: 8 }}>ID {ap.id} · {ap.online ? 'online' : (ap.ultimo_visto ? `visto ${fmtHora(ap.ultimo_visto)}` : 'nunca conectou')}</div>

                {/* Botões de modo */}
                <div style={{ display: 'flex', gap: 4, marginBottom: 8 }}>
                  {['prospectar', 'aquecer', 'pausado'].map(m => {
                    const on = ap.modo === m; const info = MODO_INFO[m];
                    return (
                      <button key={m} onClick={() => !on && editarAparelho(ap.id, { modo: m })}
                        style={{ flex: 1, padding: '4px 2px', fontSize: 10.5, fontWeight: 700, borderRadius: 6, cursor: 'pointer', border: `1px solid ${on ? info.cor : '#e5e7eb'}`, background: on ? info.bg : '#fff', color: on ? info.cor : '#9ca3af' }}>
                        {info.rot}
                      </button>
                    );
                  })}
                </div>
                {emAlmoco && <div style={{ fontSize: 10.5, color: '#b45309', marginBottom: 6 }}>⏸️ em horário de almoço → aquecendo agora</div>}

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, fontSize: 11.5 }}>
                  <div>
                    <span style={{ ...lbl, fontSize: 10.5 }}>Telefone (pro aquecedor)</span>
                    <input defaultValue={ap.telefone} placeholder="83 9..." onBlur={e => editarAparelho(ap.id, { telefone: e.target.value })}
                      style={{ ...campo, padding: '5px 8px', fontSize: 12 }} />
                  </div>
                  <div>
                    <span style={{ ...lbl, fontSize: 10.5 }}>Lista atribuída</span>
                    <select value={ap.lista_id || ''} onChange={e => editarAparelho(ap.id, { lista_id: e.target.value })} style={{ ...campo, padding: '5px 8px', fontSize: 12 }}>
                      <option value="">— todas livres —</option>
                      {(st.listas || []).map(l => <option key={l.id} value={l.id}>{l.nome}</option>)}
                    </select>
                  </div>
                  <div>
                    <span style={{ ...lbl, fontSize: 10.5 }}>Almoço de</span>
                    <input type="time" defaultValue={ap.almoco_ini} onBlur={e => editarAparelho(ap.id, { almoco_ini: e.target.value })} style={{ ...campo, padding: '5px 8px', fontSize: 12 }} />
                  </div>
                  <div>
                    <span style={{ ...lbl, fontSize: 10.5 }}>até</span>
                    <input type="time" defaultValue={ap.almoco_fim} onBlur={e => editarAparelho(ap.id, { almoco_fim: e.target.value })} style={{ ...campo, padding: '5px 8px', fontSize: 12 }} />
                  </div>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 8, fontSize: 11.5, color: '#374151', borderTop: '1px solid #f3f4f6', paddingTop: 6 }}>
                  <span style={{ fontWeight: 700, color: mi.cor }}>{mi.rot}</span>
                  <span>{ap.enviadas_hoje} enviada(s) hoje</span>
                </div>
                {ap.ultima_acao && <div style={{ fontSize: 10.5, color: '#9ca3af', marginTop: 2 }}>última: {ap.ultima_acao}</div>}
                {/* 📸 Print da tela: a ponte atende no próximo ping (~3 min);
                    a foto chega no WhatsApp do Vagner e vira miniatura aqui */}
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 6 }}>
                  <button onClick={async () => {
                    try {
                      const r = await fetch(`/sdr/virtual/aparelhos/${ap.id}/print`, { method: 'POST', headers: { Authorization: `Bearer ${token()}` } });
                      const d = await r.json();
                      alert(r.ok ? '📸 ' + (d.aviso || 'Pedido enviado.') : (d.erro || 'Falhou'));
                    } catch (e) { alert('Falhou: ' + e.message); }
                  }}
                    title="Fotografa a tela do celular — chega no seu WhatsApp e aparece aqui em até ~3 min"
                    style={{ background: '#fff', border: '1px solid #c8d0da', borderRadius: 5, padding: '3px 10px', fontSize: 11.5, fontWeight: 700, color: '#374151', cursor: 'pointer' }}>
                    📸 Print da tela
                  </button>
                  <MiniPrint id={ap.id} />
                </div>
              </div>
            );
          })}
        </div>
        <div style={{ fontSize: 11.5, color: '#6b7280', marginTop: 10 }}>
          O modo vale em até 30 min (a ponte relê a cada rodada). <b>Almoço</b>: no horário marcado o aparelho troca sozinho de prospectar pra aquecer, e volta depois. Aparelho novo entra <b>pausado</b> por segurança.
        </div>
      </div>

      {/* ── Configurações ── */}
      <div style={{ ...card, marginBottom: 16 }}>
        <div style={{ fontSize: 15, fontWeight: 800, color: '#0a1628', marginBottom: 10 }}>⚙️ Configurações</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 12 }}>
          <div><span style={lbl}>Abordagens por dia</span>{numInput('teto_dia', 1, 40)}</div>
          <div><span style={lbl}>Intervalo mínimo (min)</span>{numInput('min_intervalo_min', 1, 60)}</div>
          <div><span style={lbl}>Intervalo máximo (min)</span>{numInput('max_intervalo_min', 1, 120)}</div>
          <div><span style={lbl}>Começa às (hora)</span>{numInput('hora_ini', 0, 23)}</div>
          <div><span style={lbl}>Para às (hora)</span>{numInput('hora_fim', 1, 24)}</div>
          <div>
            <span style={lbl}>Tipo de abordagem</span>
            <select style={campo} value={cfg?.tipo_abordagem || 'texto'} onChange={e => setCfg({ ...cfg, tipo_abordagem: e.target.value })}>
              <option value="texto">💬 Saudação de texto (SDR humana assume)</option>
              <option value="audio">🎙️ Áudio de abordagem</option>
            </select>
          </div>
          <div>
            <span style={lbl}>Avisar respostas no WhatsApp</span>
            <input style={campo} placeholder="83986987687" value={cfg?.notificar_whatsapp ?? ''}
              onChange={e => setCfg({ ...cfg, notificar_whatsapp: e.target.value })} />
          </div>
        </div>
        {(cfg?.tipo_abordagem || 'texto') === 'texto' && (
          <div style={{ marginTop: 12 }}>
            <span style={lbl}>Saudações — uma por linha (a ponte sorteia; "Bom dia"/"Boa tarde" respeitam a hora)</span>
            <textarea rows={5} style={{ ...campo, fontFamily: 'inherit', resize: 'vertical' }}
              value={cfg?.saudacoes ?? ''} onChange={e => setCfg({ ...cfg, saudacoes: e.target.value })}
              placeholder={'Oi\nTudo bem?\nBoa tarde\nBom dia\nOi, tudo bem?'} />
          </div>
        )}

        {/* Aquecedor de chip: conversa entre os próprios aparelhos */}
        <div style={{ marginTop: 14, borderTop: '1px solid #eef1f5', paddingTop: 12 }}>
          <div style={{ fontSize: 14, fontWeight: 800, color: '#b45309', marginBottom: 8 }}>🔥 Aquecedor de chip</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12 }}>
            <div>
              <span style={lbl}>Aquecimentos por saudação</span>
              <input type="number" min={0} max={10} style={campo} value={cfg?.aquecer_por_saudacao ?? 2}
                onChange={e => setCfg({ ...cfg, aquecer_por_saudacao: e.target.value })} />
              <div style={{ fontSize: 10.5, color: '#6b7280', marginTop: 3 }}>0 = desligado · 2 = duas conversas entre cada abordagem</div>
            </div>
          </div>
          <div style={{ marginTop: 10 }}>
            <span style={lbl}>Banco de diálogos — uma fala por linha (os aparelhos trocam entre si, com ritmo humano)</span>
            <textarea rows={6} style={{ ...campo, fontFamily: 'inherit', resize: 'vertical' }}
              value={cfg?.dialogos ?? ''} onChange={e => setCfg({ ...cfg, dialogos: e.target.value })}
              placeholder={'Bom dia! Tudo certo por aí?\nTudo sim, e contigo?\nAquele cliente fechou?\nFechou ontem à tarde 🙌'} />
          </div>
          <div style={{ fontSize: 11.5, color: '#6b7280', marginTop: 6 }}>
            Precisa de <b>2+ aparelhos com telefone preenchido</b> lá em cima — eles conversam entre si pra parecer uso normal do WhatsApp. Só aparelhos não-pausados servem de par.
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 12, flexWrap: 'wrap' }}>
          <button onClick={salvar} disabled={salvando}
            style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 22px', fontWeight: 700, fontSize: 14, cursor: 'pointer' }}>
            {salvando ? 'Salvando…' : 'Salvar'}
          </button>
          <button onClick={rearmarTeste}
            title="Re-arma o seu contato de teste — a ponte te manda a saudação de novo (modo teste)"
            style={{ background: '#fff', color: '#0a1628', border: '1.5px solid #c8d0da', borderRadius: 8, padding: '8px 18px', fontWeight: 700, fontSize: 13.5, cursor: 'pointer' }}>
            🔄 Testar no meu WhatsApp
          </button>
          {msg && <span style={{ fontSize: 13, color: msg.startsWith('✓') ? '#16a34a' : '#dc2626' }}>{msg}</span>}
        </div>
        <div style={{ fontSize: 12, color: '#6b7280', marginTop: 8 }}>
          ⚠️ Subir demais o teto/ritmo aumenta o risco de banimento do chip no WhatsApp. O padrão (10/dia, 3–8 min) é o perfil de aquecimento seguro.
        </div>
      </div>

      {/* ── Listas ligadas ── */}
      <div style={{ ...card, marginBottom: 16 }}>
        <div style={{ fontSize: 15, fontWeight: 800, color: '#0a1628', marginBottom: 8 }}>📋 Listas com a saudadora ligada</div>
        {st && st.listas.length === 0 && <div style={{ fontSize: 13, color: '#6b7280' }}>Nenhuma. Vá na tela <b>SDR</b> e clique no 🤖 da lista que deve entrar na fila.</div>}
        {st && st.listas.map(l => (
          <div key={l.id} style={{ display: 'flex', justifyContent: 'space-between', gap: 8, padding: '8px 0', borderBottom: '1px solid #eef1f5', fontSize: 13, flexWrap: 'wrap' }}>
            <span style={{ fontWeight: 700, color: '#0a1628' }}>🤖 {l.nome}</span>
            <span style={{ color: '#6b7280' }}>{l.novos} na fila · {l.aguardando} aguardando retorno · {l.erros > 0 ? <b style={{ color: '#dc2626' }}>{l.erros} erro(s)</b> : 'sem erros'} · {l.total} no total</span>
          </div>
        ))}
      </div>

      {/* ── Últimos abordados + erros ── */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 10, marginBottom: 16 }}>
        <div style={card}>
          <div style={{ fontSize: 14, fontWeight: 800, color: '#0a1628', marginBottom: 8 }}>🕐 Últimas abordagens</div>
          {st && st.ultimos.length === 0 && <div style={{ fontSize: 13, color: '#6b7280' }}>Nenhuma ainda.</div>}
          {st && st.ultimos.map((u, i) => (
            <div key={i} style={{ fontSize: 12.5, padding: '5px 0', borderBottom: '1px solid #f3f4f6' }}>
              <b>{u.nome}</b> · {u.telefone} <span style={{ color: '#6b7280', float: 'right' }}>{fmtHora(u.em)}</span>
            </div>
          ))}
        </div>
        <div style={card}>
          <div style={{ fontSize: 14, fontWeight: 800, color: '#0a1628', marginBottom: 8 }}>⚠️ Erros de envio recentes</div>
          {st && st.erros.length === 0 && <div style={{ fontSize: 13, color: '#16a34a' }}>Nenhum erro. 🎉</div>}
          {st && st.erros.map((e2, i) => (
            <div key={i} style={{ fontSize: 12.5, padding: '5px 0', borderBottom: '1px solid #f3f4f6' }}>
              <b>{e2.nome}</b> · {e2.telefone}<br /><span style={{ color: '#dc2626' }}>{e2.erro}</span> <span style={{ color: '#6b7280', float: 'right' }}>{fmtHora(e2.em)}</span>
            </div>
          ))}
        </div>
      </div>

      {/* ── Documentação ── */}
      <div style={{ ...card }}>
        <div style={{ fontSize: 15, fontWeight: 800, color: '#0a1628', marginBottom: 10 }}>📖 Como operar (documentação)</div>

        <details style={{ marginBottom: 8 }}>
          <summary style={{ cursor: 'pointer', fontWeight: 700, fontSize: 13.5, color: '#0a1628' }}>Como funciona (a arquitetura)</summary>
          <div style={{ fontSize: 13, color: '#374151', padding: '8px 4px', lineHeight: 1.7 }}>
            <b>Sistema (fila)</b> → <b>PC do escritório (ponte)</b> → <b>celular da SDR (WiFi, sem cabo)</b> → <b>WhatsApp Business → lead</b>.<br />
            A ponte checa a fila a cada 30 min e manda a <b>saudação de texto</b> (sorteada da lista acima) no ritmo configurado — o contato vira <b>"aguardando"</b>.
            <b>Quem responder, a SDR humana assume a conversa</b> (no próprio celular ou pareando o WhatsApp Web dele no computador dela). Os áudios são a fase seguinte — é só trocar o tipo de abordagem acima.
          </div>
        </details>

        <details style={{ marginBottom: 8 }}>
          <summary style={{ cursor: 'pointer', fontWeight: 700, fontSize: 13.5, color: '#0a1628' }}>Iniciar uma prospecção (passo a passo)</summary>
          <div style={{ fontSize: 13, color: '#374151', padding: '8px 4px', lineHeight: 1.8 }}>
            1. Crie/importe a lista na tela <b>SDR</b> (Excel, Radar RPI, Maps, Órfãos…)<br />
            2. Clique no <b>🤖</b> do cartão da lista pra ligar a saudadora nela<br />
            3. Garanta os áudios .m4a na pasta <code>audios_sdr</code> do PC do escritório<br />
            4. No PC: janela do <code>3-LIGAR-PONTE.bat</code> aberta (e <code>SDR_LIBERADO=1</code> pra clientes reais)<br />
            5. Acompanhe por esta página — abordados, fila e erros ao vivo
          </div>
        </details>

        <details style={{ marginBottom: 8 }}>
          <summary style={{ cursor: 'pointer', fontWeight: 700, fontSize: 13.5, color: '#0a1628' }}>Conectar/reconectar o celular (ou um novo)</summary>
          <div style={{ fontSize: 13, color: '#374151', padding: '8px 4px', lineHeight: 1.8 }}>
            Pacote <b>v6</b>: <code>preservamarcas.com.br/dl-33fb0b6dc0a6/PONTE-SDR-WINDOWS.zip</code> → extrair na Área de Trabalho.<br />
            1. <code>1-INSTALAR.bat</code> (uma vez) · 2. Celular no cabo USB → <code>2-CONECTAR-CELULAR.bat</code> → aceitar "Permitir depuração" no aparelho (é <b>por computador</b>) → "DEU CERTO" com o modelo.<br />
            3. Abra o <code>3-LIGAR-PONTE.bat</code> no Bloco de Notas e cole o <b>ID do aparelho</b> (aparece no card dele aqui em cima) na linha <code>SDR_APARELHO</code>.<br />
            <b>Outro celular</b>: copiar a pasta com outro nome, repetir o passo 2 nela e usar o ID do outro aparelho — cada pasta guarda o IP do seu.
          </div>
        </details>

        <details style={{ marginBottom: 8 }}>
          <summary style={{ cursor: 'pointer', fontWeight: 700, fontSize: 13.5, color: '#0a1628' }}>🆕 Ligar sozinho e sobreviver a reinício (v6)</summary>
          <div style={{ fontSize: 13, color: '#374151', padding: '8px 4px', lineHeight: 1.8 }}>
            <b>Início automático</b> — rode o <code>5-INSTALAR-AUTOINICIO.bat</code> (como Administrador) e escolha o que aquele computador faz: ponte, reativador ou os dois. Dali em diante sobe sozinho quando o PC liga.<br />
            <b>Celular reiniciou</b> — o Android mata o modo WiFi do ADB e só o cabo ressuscita. Solução: deixe o celular <b>plugado no USB do computador da SDR</b> e rode lá o <code>4-RODAR-REATIVADOR.bat</code> (pode minimizar). Ele religa o WiFi sozinho, e a ponte central reconecta em seguida — sem trabalho manual.<br />
            <b>Celulares em outra mesa</b> — o controle é pelo WiFi: uma ponte só, no seu PC, comanda os celulares da Bianca e da Tacila. Nos computadores delas roda apenas o reativador. Só lembre de aceitar a janelinha de depuração uma vez em cada computador.
          </div>
        </details>

        <details>
          <summary style={{ cursor: 'pointer', fontWeight: 700, fontSize: 13.5, color: '#0a1628' }}>Problemas comuns</summary>
          <div style={{ fontSize: 13, color: '#374151', padding: '8px 4px', lineHeight: 1.8 }}>
            <b>unauthorized / failed to authenticate</b> → aceitar a janelinha de depuração no celular (sempre permitir)<br />
            <b>Erro 10060 / ping sem resposta</b> → PC e celular em redes diferentes ou roteador com isolamento de WiFi<br />
            <b>"fora do horário comercial"</b> → normal fora da janela configurada (modo teste ignora)<br />
            <b>Fila vazia</b> → teto do dia atingido, lista sem contatos novos, ou nenhuma lista com 🤖 ligado<br />
            A documentação completa (com todas as lições) está no Obsidian: <i>SDR Virtual — Ponte do Celular</i>.
          </div>
        </details>
      </div>
    </div>
  );
}
